import { render, staticRenderFns } from "./Collection2022.vue?vue&type=template&id=1d23c0d6&scoped=true&"
import script from "./Collection2022.vue?vue&type=script&lang=js&"
export * from "./Collection2022.vue?vue&type=script&lang=js&"
import style0 from "./Collection2022.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Collection2022.vue?vue&type=style&index=1&id=1d23c0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d23c0d6",
  null
  
)

export default component.exports